import React from 'react';
import { Stack } from '@mui/material';
import { AssetGroupsCurveDeteriorationMethodsTable } from './AssetGroupsCurveDeteriorationMethodsTable';
import { DeteriorationModelConfigurationCard } from './DeteriorationModelConfigurationCard';

interface DeteriorationModelConfigurationTabProps {
	onUpdateFailureDefinition: (newFailureDefinitionId: string) => Promise<void>;
	onUnsavedChangesChange?: (hasUnsavedChanges: boolean) => void;
}

export const DeteriorationModelConfigurationTab = ({
	onUpdateFailureDefinition,
	onUnsavedChangesChange,
}: DeteriorationModelConfigurationTabProps) => {
	return (
		<Stack spacing={2}>
			<DeteriorationModelConfigurationCard onUpdateFailureDefinition={onUpdateFailureDefinition} />
			<AssetGroupsCurveDeteriorationMethodsTable onUnsavedChangesChange={onUnsavedChangesChange} />
		</Stack>
	);
};
